export default "__VITE_ASSET__DYlWrUMb__"